import { useFormik } from "formik";
import * as yup from "yup";
import "./Newsletter.scss";
import { FaGoogle, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { useContext } from "react";
import MyContext from "../../../Uttis/MyContext";

const Newsletter = () => {
  const { location, setSnack, setLoading, setMessage, url } = useContext(MyContext);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: yup.object({
      email: yup.string().email("Enter a valid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      document.body.style.overflow = "hidden";
      try {
        const response = await fetch(`${url}/subscribe`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        });

        const data = await response.json();
        setSnack(true);
        setMessage(data.message);
        if (data.success) resetForm();
      } catch (error) {
        alert(error.message);
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
      }
    },
  });

  const isFooterVisible = ["/vxeditor", "/admino"];
  if (
    location.pathname.match(
      /^\/(html|learning|react-native|sql|css|student-registration|css-advance|javascript|project|reactjs|vxeditor|express-js|excel|cyber-security|php)\//
    ) || isFooterVisible.includes(location.pathname)
  ) {
    return null;
  }

  return (
    <section className="newsletter-section">
      <div className="newsletter-content">
        <span className="small-text">Newsletter</span>
        <span className="big-text">Sign up for the latest updates</span>

        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="form-field">
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="error">{formik.errors.email}</div>
            )}
          </div>
          <button type="submit" className="subscribe-btn">
            Subscribe
          </button>
        </form>

        <div className="text">We respect your privacy and never spam.</div>

        <div className="social-icons">
          <a
            href="https://www.linkedin.com/company/v-ex-tech-software-company-in-vadodara/"
            target="_blank"
            rel="noreferrer"
            className="icon linkedin"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/v_extech/?igshid=Zjc2ZTc4Nzk%3D"
            target="_blank"
            rel="noreferrer"
            className="icon instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://share.google/2sWWtJ589dxWA8pR0"
            target="_blank"
            rel="noreferrer"
            className="icon google"
          >
            <FaGoogle />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
